<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <!-- upload -->
          <div v-bind:class="{ 'd-none': !hideMap }">
            <v-row>
              <v-col cols="6">
                <v-card-title>
                  <v-file-input :label="$tt('customFieldUploadFileInput')" @change="setUploadFile"></v-file-input>
                </v-card-title>
                <v-card-actions>
                  <v-btn @click="cancel()" color="secondary" class="white--text text-none">{{
                    $tt('customCancel')
                  }}</v-btn>
                  <v-btn @click="uploadGeoFile()" v-bind:disabled="!canUpload()" color="primary" class="text-none">{{
                    $tt('customUpload')
                  }}</v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="6">
                <v-card-title>
                  <v-select
                    v-model="selectGeoFileEncodings"
                    :items="geoFileEncodings"
                    menu-props="auto"
                    :label="$tt('customTextEncoding')"
                  ></v-select>
                </v-card-title>
              </v-col>
            </v-row>
          </div>

          <!-- select -->
          <div v-bind:class="{ 'd-none': hideMap }">
            <v-card-title>
              <span style="width: 300px">
                <v-select
                  v-model="selectedPropertyKey"
                  :items="geoFilePropertyKeys"
                  menu-props="auto"
                  :label="selectBoxText()"
                ></v-select>
              </span>
              <v-btn @click="cancel()" color="secondary" class="white--text text-none" style="margin-left: 10px">{{
                $tt('customCancel')
              }}</v-btn>
              <v-btn
                @click="importGeoJson()"
                color="red"
                :disabled="geoFileInfo.count === 0"
                class="white--text text-none"
                style="margin-left: 10px"
                >{{ btnText() }}</v-btn
              >
            </v-card-title>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="py-0">
      <v-col id="map-container" class="py-0">
        <gmap-map
          ref="googleMapRef"
          class="py-0"
          :center="mapCenter"
          :zoom="mapZoom"
          :options="{ streetViewControl: false, rotateControl: false, fullscreenControl: false }"
          map-type-id="roadmap"
          style="height: 74vh"
          :class="{ invisible: hideMap }"
        >
          <GmapMarker :key="index" v-for="(marker, index) in markers" :position="marker.position" :clickable="true" />
          <gmap-info-window
            @closeclick="isInfoWindowOpen = false"
            :opened="isInfoWindowOpen"
            :position="infoWindowPosition"
          >
            <v-row no-gutters class="py-0" align="center">
              <v-col cols="auto">
                <v-checkbox
                  class="pt-4"
                  v-model="isImport"
                  @change="changeIsImport(isImport)"
                  label="取り込む"
                ></v-checkbox>
              </v-col>
              <v-col cols="auto" class="pl-4 pt-0">
                <v-btn color="primary" @click="closeInfoWindow()">OK</v-btn>
              </v-col>
            </v-row>

            <div class="properties">
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    <tr v-for="(data, i) in infoWindowData" :key="i">
                      <td>{{ data.dataName }}:</td>
                      <td>{{ data.dataValue }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </gmap-info-window>
        </gmap-map>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import * as Constants from '@/lib/constants'
import * as FieldImport from '@/lib/field-import'
import GoogleMapMixin from '@/components/mixins/google-map-mixin'
import MapMixin from '@/components/mixins/map-mixin'
import Toast from '@/lib/toast'
import i18n from '@/lib/i18n'

export default {
  name: 'GeoFileImport',
  mixins: [MapMixin, GoogleMapMixin],
  props: {
    importMode: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      geoFile: null,

      selectGeoFileEncodings: 'UTF-8',
      geoFileEncodings: ['UTF-8', 'Shift_JIS'],
      geoFilePropertyKeys: [''],
      selectedPropertyKey: '',
      geoFileInfo: { count: 0 },
      markers: [],
      infoWindowPosition: null,
      isInfoWindowOpen: false,
      infoWindowData: [],
      isImport: true,
      importFeatures: [],
      selectedFeatureId: 0,
    }
  },
  mounted() {
    this.$store.dispatch('initFieldImport')
  },
  computed: {
    mapCenter() {
      return this.getDefaultMapCenter()
    },
    mapZoom() {
      return this.getDefaultZoomLevel()
    },
    hideMap() {
      return this.$store.getters.fieldImport.hideMap
    },
  },
  methods: {
    changeIsImport(isImport) {
      this.importFeatures.forEach(feature => {
        if (feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ID] === this.selectedFeatureId) {
          if (isImport) {
            feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED] = FieldImport.YES
          } else {
            feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED] = FieldImport.NO
          }
        }
      })

      const mustImportFeatures = this.importFeatures.filter(is => {
        if (is.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED] === FieldImport.YES) {
          return is
        }
      })

      this.$refs.googleMapRef.$mapPromise.then(map => {
        map.data.forEach(feature => {
          const id = feature.getProperty(FieldImport.GEOJSON_PROPERTY_FIELD_ID)
          if (id === this.selectedFeatureId) {
            if (isImport) {
              feature.setProperty(FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED, FieldImport.YES)
            } else {
              feature.setProperty(FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED, FieldImport.NO)
            }
          }
        })
      })
      this.geoFileInfo.count = mustImportFeatures.length
    },
    showInfoWindow(event) {
      const feature = event.feature
      const latLng = event.latLng

      this.selectedFeatureId = feature.getProperty(FieldImport.GEOJSON_PROPERTY_FIELD_ID)

      this.importFeatures.forEach(feature => {
        if (feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ID] === this.selectedFeatureId) {
          if (feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED] === FieldImport.YES) {
            this.isImport = true
          } else {
            this.isImport = false
          }
        }
      })
      this.infoWindowData = []
      this.geoFilePropertyKeys.forEach(name => {
        if (name) {
          let data = { dataName: null, dataValue: null }
          data.dataName = name
          const value = feature.getProperty(name)
          data.dataValue = value
          this.infoWindowData.push(data)
        }
      })

      this.infoWindowPosition = latLng
      this.isInfoWindowOpen = true
    },
    closeInfoWindow() {
      this.isInfoWindowOpen = false
    },
    cancel() {
      if (this.importMode === Constants.IMPORT_MODE.FIELDS) {
        this.$router.push({ name: 'FieldListAsList' })
      }
      if (this.importMode === Constants.IMPORT_MODE.REFLINES) {
        this.$router.push({ name: 'RefLineAdd' })
      }
    },
    selectBoxText() {
      if (this.importMode === Constants.IMPORT_MODE.FIELDS) {
        return i18n.tt('customFileUploadAttributeNameForFieldName')
      }
      if (this.importMode === Constants.IMPORT_MODE.REFLINES) {
        return i18n.tt('customFileUploadAttributeNameForRefLineName')
      }
    },
    btnText() {
      if (this.importMode === Constants.IMPORT_MODE.FIELDS) {
        return i18n.tt('customFileUploadFieldImportStart', { count: this.geoFileInfo.count })
      }
      if (this.importMode === Constants.IMPORT_MODE.REFLINES) {
        return i18n.tt('customFileUploadRefLineImportStart', { count: this.geoFileInfo.count })
      }
    },
    canUpload() {
      if (this.geoFile == null) {
        return false
      }
      return true
    },
    importGeoJson() {
      const mustImportFeatures = this.importFeatures.filter(is => {
        if (is.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED] === FieldImport.YES) {
          return is
        }
      })
      if (this.importMode === Constants.IMPORT_MODE.FIELDS) {
        if (Constants.IMPORT_LIMIT.FIELDS < mustImportFeatures.length) {
          Toast.i18nError('customImportLimitMessage', { limit: Constants.IMPORT_LIMIT.FIELDS })
          return
        }
      }
      if (this.importMode === Constants.IMPORT_MODE.REFLINES) {
        if (Constants.IMPORT_LIMIT.REFLINES < mustImportFeatures.length) {
          Toast.i18nError('customImportLimitMessage', { limit: Constants.IMPORT_LIMIT.REFLINES })
          return
        }
      }

      let request = { features: mustImportFeatures, propertyAsName: this.selectedPropertyKey }

      if (this.importMode === Constants.IMPORT_MODE.FIELDS) {
        this.$store.dispatch('importFields', request)
        this.$router.push({ name: 'FieldListAsList' })
      }
      if (this.importMode === Constants.IMPORT_MODE.REFLINES) {
        this.$store.dispatch('importRefLines', request)
        this.$router.push({ name: 'RefLineListAsList' })
      }

      Toast.i18nSuccess('customFileUploadFieldImportStartedMessage')
    },
    setUploadFile() {
      event.preventDefault()
      const files = event.target.files
      if (files) {
        this.geoFile = files[0]
      }
    },
    uploadGeoFile() {
      const request = {
        geoFile: this.geoFile,
        encoding: this.selectGeoFileEncodings,
        geoFilePropertyKeys: this.geoFilePropertyKeys,
        geoFileInfo: this.geoFileInfo,
        mode: this.importMode,
        googleMap: this.$refs.googleMapRef,
        markers: this.markers,
        importFeatures: this.importFeatures,
        showInfoWindow: this.showInfoWindow,
      }
      this.$store.dispatch('uploadGeoFile', request)
    },
  },
}
</script>
<style lang="scss">
.importFieldPopUp {
  table {
    border: 1px #555 solid;
    border-collapse: collapse;
    width: 100%;
  }
  td {
    padding: 2px;
    border: 1px #555 solid;
    border-collapse: collapse;
  }
  th {
    padding: 2px;
    border: 1px #555 solid;
    border-collapse: collapse;
  }
  .properties {
    min-width: 150px;
    margin-top: 1em;
    max-height: 150px;
    overflow: auto;
  }
  .selector {
    /*margin-top: 1em;*/
  }
  #closePopUpButton {
    float: right;
  }
}
.invisible {
  visibility: hidden;
}
</style>
